<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>

import store from '../js/vuex/store';

export default {
  data() {
    return {
    };
  },
  store,
  mounted() {},
  methods: {
  }
};
</script>

<style>
  html {
    font-size: 0.8em;
  }
  body {
    font-size: 0.9em !important;
  }
  /* evitar a quebra de atalhos datepicker */
  .h-date-picker .h-date-shortcut {
    width: 110px !important;
  }
</style>
